import { createFileRoute } from "@tanstack/react-router";

import { IndexLayoutPage } from "@/features/layout/index-layout-page";

export const Route = createFileRoute("/_index")({
  component: RouteComponent,
});

function RouteComponent() {
  const { roles } = Route.useRouteContext();
  return <IndexLayoutPage roles={roles} />;
}
